<template>
  <div class="card-container">
    <common-top-form
      :model="formModel"
      :submitService="submitService"
      :submitData="submitData"
      @success="onSuccess"
      @openAddDialog="openAddDialog"
      :show="true"
      :selectShow="true"
      :goback="true"
      selectShowPower="/roulettelotteryfalse/select"
      addShowPower="/roulettelotteryfalse/add"
    >
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
      <el-table-column
        prop="money"
        label="金额"
        min-width="100"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="commodityNumber"
        label="奖品数量"
        min-width="100"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column prop="imgUrl" label="奖品图片" min-width="100">
        <template slot-scope="scope">
          <div
            class="iconUrl"
            :style="
              'background:url(' + scope.row.imgUrl + ') center/cover no-repeat'
            "
          ></div>
        </template>
      </el-table-column>
      <el-table-column
        prop="ifPrize"
        label="奖品种类"
        min-width="100"
        :formatter="goodsType"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="概率区间">
        <template slot-scope="scope">
          {{
            scope.row.probabilitySectionStart +
            "~" +
            scope.row.probabilitySectionEnd
          }}
        </template>
        ></el-table-column
      >
      <el-table-column label="操作" min-width="160">
        <template slot-scope="scope">
          <el-button type="text" @click="openAddDialog(scope.row)"
            >修改
          </el-button>
          <el-button type="text" @click="handleDelete(scope.row)"
            >删除
          </el-button>
        </template>
      </el-table-column>
    </common-table>
    <form-dialog
      ref="formDialog"
      :formDialogTitle="itemId ? '修改' : '添加'"
      :model="dialogModel"
      :submitData="dialogData"
      labelWidth="120px"
      dialogWidth="505px"
      :rules="dialogRules"
      :dialogService="dialogService"
      @close="dialogClose"
      @success="dialogSuccess"
      class="note"
    >
      <el-form-item label="金额" prop="money">
        <el-input
          type="text"
          maxlength="10"
          v-model="dialogModel.money"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="奖品数量" prop="commodityNumber">
        <el-input
          type="text"
          maxlength="10"
          v-model="dialogModel.commodityNumber"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="奖品图片" prop="imgUrl">
        <el-upload
          class="avatar-uploader"
          :action="uploadUrl + '8883/picture/upload'"
          :data="commonParams"
          name="picture"
          :show-file-list="false"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload"
        >
          <img
            v-if="dialogModel.imgUrl"
            :src="dialogModel.imgUrl"
            class="avatar"
          />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <el-form-item label="概率区间" required>
        <div style="display: flex">
          <el-form-item prop="probabilitySectionStart">
            <el-input-number
              @change="bian()"
              :controls="false"
              type="text"
              maxlength="5"
              style="width: 160px"
              v-model="dialogModel.probabilitySectionStart"
              placeholder="请输入"
            ></el-input-number>
          </el-form-item>
          ~
          <el-form-item prop="probabilitySectionEnd" style="margin-left: 15px">
            <el-input-number
              @change="bian()"
              :controls="false"
              type="text"
              maxlength="5"
              style="width: 162px"
              v-model="dialogModel.probabilitySectionEnd"
              placeholder="请输入"
            ></el-input-number>
          </el-form-item>
        </div>
      </el-form-item>
      <el-form-item label="是否中奖" prop="ifPrize">
        <el-radio-group v-model="dialogModel.ifPrize">
          <el-radio :label="0">是</el-radio>
          <el-radio :label="1">否</el-radio>
        </el-radio-group>
      </el-form-item>
    </form-dialog>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import FormDialog from "../../dialog/FormDialog";
import ShowInfoDialog from "../../dialog/ShowInfoDialog";

import APPService from "service/APPService";

import Server from "common/conf/Server";
import privateKey from "service/constant/privateKey";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "configureprizes",
  components: {
    CommonTopForm,
    CommonTable,
    FormDialog,
    ShowInfoDialog,
  },
  data() {
    return {
      uploadUrl: Server[process.env.NODE_ENV],
      id: "",
      // 标题
      itemId: "",
      formModel: {},
      tableData: [],
      submitService: APPService.configListFalse,
      page: {},
      isPage: false,
      dialogModel: {
        money: "",
        commodityNumber: "",
        probabilitySectionStart: "",
        probabilitySectionEnd: "",
        imgUrl: "",
        ifPrize: "",
      },
      dialogRules: {
        money: [
          {
            required: true,
            message: "请输入",
          },
        ],
        commodityNumber: [
          {
            required: true,
            message: "请输入奖品数量",
          },
        ],
        imgUrl: [
          {
            required: true,
            message: "请选择图片",
          },
        ],
        ifPrize: [
          {
            required: true,
            message: "请选择",
          },
        ],
        probabilitySectionStart: [
          {
            required: true,
            trigger: "blur",
            validator: (rule, value, callback) => {
              const boolean = new RegExp("^[0-9]*$").test(value);
              if (!boolean) {
                callback(new Error("请输入"));
              } else {
                callback();
              }
            },
          },
        ],
        probabilitySectionEnd: [
          {
            required: true,
            trigger: "blur",

            validator: (rule, value, callback) => {
              const boolean = new RegExp("^[0-9]*$").test(value);

              if (!boolean) {
                return callback(new Error("请输入"));
              }

              if (
                this.dialogModel.probabilitySectionStart >
                this.dialogModel.probabilitySectionEnd
              ) {
                callback(new Error("不能小于前者"));
              } else {
                callback();
              }
            },
          },
        ],
      },
      enableStatus: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "0",
          label: "禁用",
        },
        {
          value: "1",
          label: "启用",
        },
      ],
    };
  },
  inject: ["reload"],
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  mounted() {
    this.id = this.$route.params.item;
    this.load();
  },
  computed: {
    submitData() {
      this.params = {
        id: this.id,
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };

      return this.params;
    },
    dialogData() {
      const params = {
        pondId: this.id,
        imgUrl: this.dialogModel.imgUrl,
        money: this.dialogModel.money,
        commodityNumber: this.dialogModel.commodityNumber,
        probabilitySectionStart: this.dialogModel.probabilitySectionStart,
        probabilitySectionEnd: this.dialogModel.probabilitySectionEnd,
        ifPrize: this.dialogModel.ifPrize,
      };
      if (this.itemId) {
        params.id = this.itemId;
      }
      return params;
    },
    dialogService() {
      return this.itemId ? APPService.configEditFalse : APPService.configAddFalse;
    },
    commonParams() {
      const params = {
        serverType: this.serverType,
        tatId: this.tatId,
        reqTime: new Date().format("yyyy-MM-dd HH:mm:ss"),
      };
      params.sign = encrypt(
        urlEncode(objKeySort(params)) + "&priKey=" + privateKey.priKey
      );
      return params;
    },
    ...mapGetters(["serverType", "tatId", "userId"]),
  },
  methods: {
    load() {
      this.formModel = {};
      this.page = this.$refs.commonTable.page;
      this.getList();
    },
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            this.onSuccess(res);
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result.rows;
        this.page.currentPage = result.current;
        this.page.total = result.total;
        this.page.pageSize = result.size;
      });
    },
    // 添加/修改
    openAddDialog(item) {
      this.itemId = item ? item.id : "";
      if (this.itemId) {
        this.dialogModel = JSON.parse(JSON.stringify(item));
      }
      this.$refs.formDialog.open();
    },

    dialogSuccess(res) {
      this.commonSuccess(res);
      this.$refs.formDialog.closeDialog();
    },

    // 删除数据
    handleDelete(item) {
      this.showConfirm("确定删除该数据？")
        .then(() => {
          this.doDelete(item.id);
        })
        .catch(() => {});
    },
    doDelete(id) {
      this.doLoad(
        APPService.configDelFalse,
        {
          id: id,
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.commonSuccess(res);
          });
        },
        "操作失败"
      );
    },
    dialogClose() {
      this.dialogModel = {
        money: "",
        commodityNumber: "",
        probabilitySectionStart: "",
        probabilitySectionEnd: "",
        imgUrl: "",
        ifPrize: "",
      };
    },
    commonSuccess(res) {
      this.showSuccess(res.respMsg);
      this.getList();
    },

    handleAvatarSuccess(res, file) {
      this.doCheck(res, (res) => {
        this.dialogModel.imgUrl = res.contents;
      });
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
        return isLt2M;
      }
      const isSize = new Promise(function (resolve, reject) {
        let width = 75;
        let height = 75;
        let _URL = window.URL || window.webkitURL;
        let img = new Image();
        img.onload = function () {
          let valid = img.width <= width && img.height <= height;
          valid ? resolve() : reject();
        };
        img.src = _URL.createObjectURL(file);
      }).then(
        () => {
          return file;
        },
        () => {
          this.$message({
            message: "奖品图请选择75*75!",
            type: "warning",
          });
          return Promise.reject();
          // return false; //必须加上return false; 才能阻止
        }
      );
      return isLt2M && isSize;
    },
    bian() {
      this.$refs.formDialog.validateField("probabilitySectionEnd");
    },
    goodsType: function (row, column) {
      switch (row.ifPrize) {
        case 0:
          return "奖金";
          break;
        case 1:
          return "谢谢惠顾";
          break;
        default:
          return "--";
      }
    },
  },
};
</script>
<style scoped>
.mem-name p {
  margin-bottom: 20px;
  vertical-align: middle;
  line-height: 40px;
  color: rgba(170, 170, 170, 1);
}

.mem-name p:first-child {
  display: inline-block;
  width: 90px;
  text-align: right;
  vertical-align: middle;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}

.iconUrl {
  width: 50px;
  height: 50px;
  margin: auto;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/view/page/AppManager/ConfigurePrizesFalse.vue